define('quote_list_expiration_date.tpl', ['Handlebars','Handlebars.CompilerNameLookup'], function(Handlebars, _nl_){
	return _wrap_fn_('quote_list_expiration_date', {"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "<span class=\"quote-list-expiration-date\"> "
    + ((stack1 = _nl_(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? _nl_(depth0,"model") : depth0)) != null ? _nl_(stack1,"duedate") : stack1),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.program(9, data, 0),"data":data,"loc":{"start":{"line":1,"column":42},"end":{"line":1,"column":496}}})) != null ? stack1 : "")
    + " </span>  ";
},"1":function(container,depth0,helpers,partials,data) {
    var stack1;

  return " "
    + ((stack1 = _nl_(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? _nl_(depth0,"model") : depth0)) != null ? _nl_(stack1,"isOverdue") : stack1),{"name":"if","hash":{},"fn":container.program(2, data, 0),"inverse":container.program(4, data, 0),"data":data,"loc":{"start":{"line":1,"column":64},"end":{"line":1,"column":436}}})) != null ? stack1 : "")
    + " ";
},"2":function(container,depth0,helpers,partials,data) {
    var stack1;

  return " <span class=\"quote-list-expiration-date-overdue\">"
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? _nl_(depth0,"model") : depth0)) != null ? _nl_(stack1,"duedate") : stack1), depth0))
    + "</span><i class=\"quote-list-expiration-date-icon-overdue\"></i> ";
},"4":function(container,depth0,helpers,partials,data) {
    var stack1;

  return " "
    + ((stack1 = _nl_(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? _nl_(depth0,"model") : depth0)) != null ? _nl_(stack1,"isCloseOverdue") : stack1),{"name":"if","hash":{},"fn":container.program(5, data, 0),"inverse":container.program(7, data, 0),"data":data,"loc":{"start":{"line":1,"column":226},"end":{"line":1,"column":428}}})) != null ? stack1 : "")
    + " ";
},"5":function(container,depth0,helpers,partials,data) {
    var stack1;

  return " <span class=\"quote-list-expiration-date-closeoverdue\">"
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? _nl_(depth0,"model") : depth0)) != null ? _nl_(stack1,"duedate") : stack1), depth0))
    + "</span><i class=\"quote-list-expiration-date-icon-closeoverdue\"></i> ";
},"7":function(container,depth0,helpers,partials,data) {
    var stack1;

  return " "
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? _nl_(depth0,"model") : depth0)) != null ? _nl_(stack1,"duedate") : stack1), depth0))
    + " ";
},"9":function(container,depth0,helpers,partials,data) {
    return " <span>"
    + container.escapeExpression((_nl_(helpers,"translate")||(depth0 && _nl_(depth0,"translate"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"Not specified",{"name":"translate","hash":{},"data":data,"loc":{"start":{"line":1,"column":452},"end":{"line":1,"column":481}}}))
    + "</span> ";
},"useData":true}, 'extensions/Dev/SGS_Latest_Theme/1.0.0/', 'extensions/Dev/SGS_Latest_Theme/1.0.0/', Handlebars);
});